import {FC} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Card from '_core/components/Card'
import {
  selectFulfillmentTracking,
  setTracking,
} from 'app/features/orders/redux/fulfillment/orderSlices'
import {RootState} from 'setup'

type Props = {
  data: any
}

const TrackingInformation: FC<Props> = () => {
  const tracking = useSelector<RootState, any>(selectFulfillmentTracking)
  const dispatch = useDispatch()

  const handleTrackingNumberChange = (e: any) => {
    const {value} = e.target
    dispatch(setTracking({trackingNumber: value}))
  }

  const handleServiceChange = (e: any) => {
    const {value} = e.target
    dispatch(setTracking({companyName: value}))
  }

  return (
    <Card title='Tracking Information (Optional)' className='card card-xl-stretch mb-5 mb-xl-8'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div className='mb-10'>
            <label className='form-label'>Tracking Number</label>
            <input
              id='txtTrackingNumbers'
              type='text'
              className='form-control'
              name='trackingNumbers'
              value={tracking.trackingNumber}
              onChange={handleTrackingNumberChange}
            />
          </div>
        </div>
        <div className='col-12 col-md-6'>
          <div className='mb-10'>
            <label className='form-label'>Shipping carrier</label>
            <input
              id='txtServices'
              type='text'
              className='form-control'
              name='service'
              value={tracking.companyName}
              onChange={handleServiceChange}
            />
            {/* <select
              id='sltServices'
              className='form-control'
              name='service'
              value={data.carrierServiceProviderId}
              onChange={handleServiceChange}
            >
              <option value=''></option>
              {shippingCarriers.map((carrier: any) => (
                <option key={carrier.id} value={carrier.carrierType}>
                  {carrier.name}
                </option>
              ))}
            </select> */}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default TrackingInformation
